import React from 'react';

const ArrowUp = () => {
	return (
		<svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M9.09053 5.83369C8.78632 5.52948 8.23158 5.52948 7.92737 5.83369L4.70632 9.05474C4.38421 9.37684 4.38421 9.89579 4.70632 10.2179C5.02842 10.54 5.54737 10.54 5.86947 10.2179L8.5 7.58737L11.1305 10.2179C11.2916 10.3789 11.5063 10.4684 11.7211 10.4684C11.9358 10.4684 12.1505 10.3789 12.3116 10.2179C12.6337 9.89579 12.6337 9.37684 12.3116 9.05474L9.09053 5.83369Z'
				fill='#323467'
			/>
			<path
				d='M8.5 3.0716e-06C3.81158 2.66173e-06 -7.5438e-07 3.81158 -1.16426e-06 8.5C-1.57413e-06 13.1884 3.81158 17 8.5 17C13.1884 17 17 13.1884 17 8.5C17 3.81158 13.1884 3.48148e-06 8.5 3.0716e-06ZM8.5 15.3537C4.72421 15.3537 1.64631 12.2758 1.64631 8.5C1.64631 4.72421 4.72421 1.64632 8.5 1.64632C12.2758 1.64632 15.3537 4.72421 15.3537 8.5C15.3537 12.2758 12.2758 15.3537 8.5 15.3537Z'
				fill='#323467'
			/>
		</svg>
	);
};

export default ArrowUp;
